import { app } from '../../../app';
import { Controller } from './client-sso-saaspass-login.controller';

app.component('clientSsoSaaspassLogin', {
    controller: Controller,
    templateUrl: require('../login/login.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/client-sso-saaspass-login/client-sso-saaspass-login.component.js